import { Chip } from '@/components/molecules/chip'

export interface FilterOption<T extends string = string> {
  key: T
  label: string
  disabled?: boolean
}

interface FilterChipsProps<T extends string = string> {
  filters: FilterOption<T>[]
  active: T
  onSelect: (key: T) => void
}

export function FilterChips<T extends string>({
  filters,
  active,
  onSelect,
}: FilterChipsProps<T>) {
  return (
    <div className="flex flex-wrap gap-2">
      {filters.map(({ key, label, disabled }) => (
        <Chip
          key={key}
          label={label}
          selected={active === key}
          disabled={disabled}
          onClick={() => onSelect(key)}
        />
      ))}
    </div>
  )
}
